import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

function PrivacyPolicyPage(props) {
  return (
    <Fragment>
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>
      <div className="about-detail row">
        <div className="text about-detail__text">
          <h1>
            Privacy Policy
          </h1>
          <p>
            Copyright, Disclaimers & Privacy Policy for Joint Commission Resources for the RTA MedSafety Tracer Tool (“Tool”)
          </p>
          <p>
            As it relates to the Content of the Tool:
            <br />
            Copyright © 2018 Joint Commission Resources, 1515 W. 22nd Street, Tower Suite, Oakbrook, IL 60523
          </p>
          <p>
            All materials posted on this site are subject to copyrights owned by the Joint Commission Resources (“JCR”). JCR hereby provides limited permission for the user of this site to reproduce, retransmit, or reprint for such user’s own personal use (and for such personal use only) part or all of any document on this site as long as the copyright notice and permission notice contained in such document or portion thereof is included in such reproduction, retransmission, or reprinting. All other reproduction, retransmission, or reprinting of all or part of any document found on this site is expressly prohibited, unless JCR has expressly granted its prior written consent to so reproduce, retransmit, or reprint the material. All other rights reserved. See Permissions/Reprints Policy.
          </p>
          <h2 className="small-h2">
            Trademarks
          </h2>
          <p>
            The names, service marks, logos and icons of JCR, or those of its affiliates, appearing on the website and the Tool may not be used in any advertising or publicity, or otherwise to indicate JCR or its affiliates sponsor or endorse or affiliate with any company, product or service, physical or virtual group, except with prior express written permission of JCR.
          </p>
          <h2 className="small-h2">
            Disclaimers
          </h2>
          <p>
            JCR is providing information, tools, policies and other documents and services on this site and through the use of the Tool as a benefit and service in furtherance of JCR’s mission. These do not or are not intended to establish a standard which requires organization compliance. JCR makes no warranties about the suitability of this information and these services for any purpose.
          </p>
          <h2 className="small-h2">
            Funding
          </h2>
          <p>
            JCR is a not-for-profit organization exempt from federal income taxation under Section 501(c)(3) of the Internal Revenue Code. JCR is a publicly-supported, charitable organization and is seeking donations from organizations or individuals whose mission and interests are aligned with JCR.
          </p>
          <h2 className="small-h2">
            Links to Other Sites and This Site
          </h2>
          <p>
            The Tool may contain links to other websites and is hosted by an outside entity. JCR is not responsible for the privacy practices or content of those sites or those of the entity hosting the Tool. Please be aware that the information you provide on any of those linked sites will not be governed by this Privacy Policy. Furthermore, JCR is only responsible for the content as received and disclaims any and all responsibility for the use of data other than as to JCR’s own use.
          </p>
          <p>
            Although this site includes links providing direct access to other Internet sites, JCR has not participated in their development and does not monitor or exert any editorial control over these sites. Further, any such linkages do not constitute any JCR endorsement of products and services appearing on other websites.
          </p>
          <h2 className="small-h2">
            Privacy Policy
          </h2>
          <p>
            Once shared with JCR, the data will be used and/or shared in aggregate, and not as it relates to any specific organization, to analyze trends in safe medication dispensing practices, and other regulatory requirements and best practices.
          </p>
          <p>
            In no event will JCR share data input by you and gathered by the Tool with The Joint Commission or Fresenius Kabi. However, JCR may share data that it aggregates with Fresenius Kabi.
          </p>
          <h2 className="small-h2">
            Usernames and Passwords
          </h2>
          <p>
            Each individual who registers to use this service has a username and password. Passwords are the private property of the user. For reasons of security and privacy, JCR will not have access to any usernames or passwords.
          </p>
          <h2 className="small-h2">
            Security Policy
          </h2>
          <p>
            We cannot guarantee that the personal information collected via the Tool will never be disclosed in some manner not consistent with this Privacy Policy by any party other than JCR. We also cannot protect against User misuse, loss, or alteration of any User editable content.
          </p>
        </div>
      </div>
    </Fragment>
  );
}

export default PrivacyPolicyPage;



// WEBPACK FOOTER //
// ./src/components/pages/PrivacyPolicyPage.js